import { render, staticRenderFns } from "./DisplayReturnLabel.vue?vue&type=template&id=482c8018"
import script from "./DisplayReturnLabel.vue?vue&type=script&lang=js"
export * from "./DisplayReturnLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports